import { baseApi } from "api/BaseApi";

import {
  TcParticipantRequestPayload,
  TechCommunity,
} from "./techCommunities.types";

const TECH_COMMUNITIES_BASE_URL = "tech/communities";

interface TechCommunitiesParams {
  isInternational: boolean;
}

const techCommunitiesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    listTechCommunities: build.query<TechCommunity[], TechCommunitiesParams>({
      query: ({ isInternational }) => ({
        url: `${TECH_COMMUNITIES_BASE_URL}/get_all/`,
        params: {
          is_international: isInternational.toString(),
        },
      }),
      providesTags: ["TECH_COMMUNITIES"],
    }),
    triggerTcParticipantRequest: build.mutation<
      void,
      TcParticipantRequestPayload
    >({
      query: (body) => ({
        url: "v2/notifications/tc-participant-request/",
        method: "POST",
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useListTechCommunitiesQuery,
  useTriggerTcParticipantRequestMutation,
} = techCommunitiesApi;
